import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=3dede4c0&scoped=true"
import script from "./Administracion.vue?vue&type=script&lang=js"
export * from "./Administracion.vue?vue&type=script&lang=js"
import style0 from "./Administracion.vue?vue&type=style&index=0&id=3dede4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dede4c0",
  null
  
)

export default component.exports